import { Alert, Button } from "@mui/material";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { t } from "i18next";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const StripePaymentForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const intentMode = useSelector((state) => state.payment.intentMode);
  const clientSecret = useSelector((state) => state.payment.paymentIntentSecret);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    if (!stripe) {
      setErrorMessage("Stripe még nem töltött be. Próbáld újra 1-2 mp múlva.");
      return;
    }
    if (!elements) {
      setErrorMessage("Stripe Elements nem elérhető. Frissítsd az oldalt.");
      return;
    }
    if (!clientSecret) {
      setErrorMessage("Hiányzik a clientSecret. Lépj vissza és indítsd újra a fizetést.");
      return;
    }

    setIsProcessing(true);
    try {
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setErrorMessage(submitError.message || "Hibás fizetési adatok.");
        return;
      }

      let result;

      if (intentMode === "setup_intent") {
        result = await stripe.confirmSetup({
          elements,
          confirmParams: {
            return_url: process.env.REACT_APP_STRIPE_RETURN_URL,
          },
          redirect: "if_required",
        });

        if (result.error) {
          setErrorMessage(result.error.message);
          return;
        }

        const status = result.setupIntent?.status;
        if (status === "succeeded" || status === "processing" || status === "requires_confirmation") {
          navigate("/dashboard");
          return;
        }

        setErrorMessage(`SetupIntent státusz: ${status || "ismeretlen"}`);
        return;
      }

      result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: process.env.REACT_APP_STRIPE_RETURN_URL,
        },
        redirect: "if_required",
      });

      if (result.error) {
        setErrorMessage(result.error.message);
        return;
      }

      const status = result.paymentIntent?.status;
      if (status === "succeeded" || status === "processing") {
        navigate("/dashboard"); 
        return;
      }

      setErrorMessage(`PaymentIntent státusz: ${status || "ismeretlen"}`);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      {errorMessage && (
        <Alert variant="filled" severity="error" sx={{ mt: 2 }}>
          {errorMessage}
        </Alert>
      )}

      <Button
        type="submit"
        disabled={!stripe || isProcessing}
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
      >
        {isProcessing ? t("payment.processing") : t("validation.buttondonext")}
      </Button>
    </form>
  );
};

export default StripePaymentForm;